import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getMembersList } from '../actions/listActions';
import { updateUmp } from '../actions/umpireActions';
import { userRoleUpdate } from '../actions/userActions';
import { userInfoUpdate } from '../actions/userActions';
import MembersList from '../components/MembersList';

const mapDispatchToProps = dispatch => {
  return {
    getMembersList: () => {
      dispatch(getMembersList());
    },
    updateUmp: (memberId, umpireLevel, plateUmpire, baseUmpire, isMentor, isActive, seasonId) => {
      dispatch(updateUmp(memberId, umpireLevel, plateUmpire, baseUmpire, isMentor, isActive, seasonId));
    },
    userRoleUpdate: (memberId, email, isAdmin) => {
      dispatch(userRoleUpdate(memberId, email, isAdmin,));
    },
    userInfoUpdate: async (memberId, email, firstName, lastName, cellPhone) => {
      console.log("Dispatching userInfoUpdate");
      console.log("Dispatched Cell Phone: " + cellPhone);
      //dispatch(userInfoUpdate(memberId, email, firstName, lastName, cellPhone));
      try {
        const response = await dispatch(userInfoUpdate(memberId, email, firstName, lastName, cellPhone));
        return response; // Return the response for handling in the component
      } catch (error) {
        console.error("Error dispatching userInfoUpdate: ", error);
        throw error; // Rethrow the error for handling in the component
      }
    }
  };
};

const mapStateToProps = state => ({
  membersList: state.lists.membersList,
  fetchingMembersList: state.lists.fetchingMembersList
});

const MembersListContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(MembersList));
export default MembersListContainer;



// WEBPACK FOOTER //
// ./src/containers/MembersListContainer.js